import { post } from "../../helpers/api";
//get
import {get } from "../../helpers/api";
const state = {
    dp_price: 0,
    currentUser: {},
    expiredItems: 0,
    isSidebarCollapsed: false,
    testVar: "test",
    sidebarItems: [],
};

const mutations = {
    SET_DP_PRICE(state, dp_price) {
        state.dp_price = dp_price;
    },
    SET_CURRENT_USER(state, currentUser) {
        state.currentUser = currentUser;
    },
    SET_EXPIRED_ITEMS(state, expiredItems) {
        state.expiredItems = expiredItems;
    },
    TOGGLE_SIDEBAR(state) {
        state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    //SET TEST
    SET_TEST_VAR(state, testVar) {
        state.testVar = testVar;
    },
    SET_SIDEBAR_ITEMS(state, sidebarItems) {
        state.sidebarItems = sidebarItems;
    },
};

const actions = {
    toggleSidebar({ commit }) {
        commit("TOGGLE_SIDEBAR");
    },
    async getItems({ commit }) {
        try {
            post("dolar-price/last", {})
                .then((response) => {
                    commit("SET_DP_PRICE", response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }
    },
    async globalSearch({ commit }, payload) {
        try {
            return post("global-search", payload, {
                    id: 40,
                    action: "view",
                })
                .then((response) => {
                    console.log(response.data);
                    commit("SET_TEST_VAR", payload.query);

                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }
    },
    async getExpiredCount({ commit }) {
        try {
            return post("item/get-number-expired", {})
                .then((response) => {
                    console.log(response.data);
                    commit("SET_EXPIRED_ITEMS", response.data);
                    return response;
                })
                .catch((error) => {
                    console.log(error);
                    return 0;
                });
        } catch (error) {
            console.log(error);
            return 0;
        }
    },
    // eslint-disable-next-line no-unused-vars
    async backup({ commit }) {
        try {
            get("backup", {})
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }
    },
    async getCurrentUser({ commit }) {
        try {
            post("user/get", {})
                .then((response) => {
                    commit("SET_CURRENT_USER", response.data);
                })
                .catch((error) => {
                    console.log(error);
                    //check if 401 go to login
                    if (error.response.status == 401) {
                        localStorage.removeItem("token_wise_manager");
                        localStorage.removeItem("user_wise_manager");
                        //go to login page
                        window.location.href = "/login";
                    }
                });
        } catch (error) {
            console.log(error);
        }
    },
    setSidebarItems({ commit }, sidebarItems) {
        commit("SET_SIDEBAR_ITEMS", sidebarItems);
    },
};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};